import _ from "lodash";
import Vue, { VueConstructor } from "vue";

declare module "vue/types/vue" {
    interface Vue {
        $_: typeof _;
    }
}

export default {
    install(Vue: VueConstructor) {
        Object.defineProperty(Vue.prototype, "$_", {
            value: _,
        });
    },
};
